import { FC } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import intl from "components/i18n/ReactIntlWrapper";

type ContactTypeSelectProps = {
  handleContactTypeChange: any;
  selectedContactTypes: any;
  contactTypes: any;
};

const ContactTypeSelect: FC<ContactTypeSelectProps> = ({
  contactTypes,
  selectedContactTypes,
  handleContactTypeChange,
}) => {
  return (
    <Autocomplete
      id="contactType"
      options={contactTypes || []}
      getOptionLabel={(option) => intl.get(option.label)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={
        contactTypes && selectedContactTypes != null
          ? contactTypes.find(
              (contactType) => contactType.id === selectedContactTypes
            )
          : null
      }
      onChange={(event, newValue) => handleContactTypeChange(newValue)}
      loading={contactTypes == null}
      renderInput={(params) => (
        <TextField
          {...params}
          label={intl.get("contactForm.placeholder.contactType")}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {contactTypes == null ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ContactTypeSelect;
